import React from 'react'
import Select from '../../basic/select'
import Button from '../../basic/button'
import {findElement, findLabel} from '../utils'
import Code from './code'
import styled from 'styled-components'
import {browserHistory} from 'react-router'
import LoaderLine from "../../basic/LoaderLine";
import * as media from '../../media'
import TranslateText from 'src/text/modal';


const Container = styled.div`
alignt-items: flex-start;
  display: flex;
  height: 55px;
  z-index: 10;
  background: #173DB0;
  padding-left: 10%;
  padding-right: 10%;
  ${media.smallerThan(1160)`padding-left: 0; padding-right: 0;`}
`

const Option = styled.option`
  font-size: 14px;
  padding: 10px 20px 10px 10px;
  background: transparent;
`

const LogoHref = styled.a`
  cursor: pointer;
  background: white;  
`

const Search = ({
  active, setActive,
  article, setArticle,
  manufacture, setManufacture, manufactures,
  model, setModel, models,
  generation, setGeneration, generations,
  variant, setVariant, variants,
  engine, setEngine, engines,
  loadingManufactures, loadingGenerations, loadingModels, loadingVariants, loadingEngines
}) => {
  return (
    <Container>
      <Code
        style={{
          flexGrow: 0,
          width: 'auto',
          height: 55,
        }}
        active={active}
        value={article}
        onFocus={() => {
          setActive('code')
        }}
        onChange={(e) => {
          setArticle(e.target.value)
        }}
      />
      {
        loadingManufactures ? <LoaderLine containerStyle={{ height: 'auto', background: 'transparent' }} loaderStyle={{ color: 'white' }} />
          :
          <TranslateText
            id="search__mark"
            style={{flexGrow: 1, height: 'auto', lineHeight: '55px', textAlign: 'center'}}
            place="bottom"
            render={text => {
              return (
                <Select
                  style={{flexGrow: 1, height: 'auto', lineHeight: '55px', textAlign: 'center'}}
                  imgNotFixed={true}
                  label={findLabel(manufactures, manufacture) || text}
                  value={manufacture}
                  onChange={(e) => {
                    const manufacture = findElement(manufactures, e.target.value)
                    setManufacture(manufacture)
                  }}
                  theme='search'
                >
                  <Option value=''/>
                  {(manufactures || []).map(o => {
                    return <Option value={o.id} key={o.id}>{o.name}</Option>
                  })}
                </Select>
              );
            }}
          />
      }
      {
        loadingModels ? <LoaderLine containerStyle={{height: 'auto', background: 'transparent'}} loaderStyle={{ color: 'white' }} />
          :
          <TranslateText
            id="search__model"
            style={{flexGrow: 1, height: 'auto', lineHeight: '55px', textAlign: 'center'}}
            place="bottom"
            render={text => {
              return (
                <Select
                  style={{flexGrow: 1, height: 'auto', lineHeight: '55px', textAlign: 'center'}}
                  imgNotFixed={true}
                  label={findLabel(models, model) || text}
                  value={model}
                  onChange={(e) => {
                    const model = findElement(models, e.target.value)
                    setModel(model)
                  }}
                  theme='search'
                  disabled={!manufacture}
                >
                  <Option value=''/>
                  {(models || []).map(o => {
                    return <Option value={o.id} key={o.id}>{o.name}</Option>
                  })}
              </Select>
              );
            }}
          />
      }
      {
        loadingGenerations ? <LoaderLine containerStyle={{height: 'auto', background: 'transparent'}} loaderStyle={{ color: 'white' }} />
          :
          <TranslateText
            id="search__generation"
            style={{flexGrow: 1, height: 'auto', lineHeight: '55px', textAlign: 'center'}}
            place="bottom"
            render={text => {
              return (
                <Select
                  style={{flexGrow: 1, height: 'auto', lineHeight: '55px', textAlign: 'center'}}
                  imgNotFixed={true}
                  label={findLabel(generations, generation) || text}
                  value={generation}
                  onChange={(e) => {
                    const generation = findElement(generations, e.target.value)
                    setGeneration(generation)
                  }}
                  theme='search'
                  disabled={!model}
                >
                  <Option value=''/>
                  {(generations || []).map(o => {
                    return <Option value={o.id} key={o.id}>{o.name}</Option>
                  })}
                </Select>
              );
            }}
          />
      }
      {
        loadingVariants ? <LoaderLine containerStyle={{height: 'auto', background: 'transparent'}} loaderStyle={{ color: 'white' }} />
          :
          <TranslateText
            id="search__year"
            style={{flexGrow: 1, height: 'auto', lineHeight: '55px', textAlign: 'center'}}
            place="bottom"
            render={text => {
              return (
                <Select
                  style={{flexGrow: 1, height: 'auto', lineHeight: '55px', textAlign: 'center'}}
                  imgNotFixed={true}
                  label={findLabel(variants, variant) || text}
                  value={variant}
                  onChange={(e) => {
                    const variant = findElement(variants, e.target.value)
                    setVariant(variant)
                  }}
                  theme='search'
                  disabled={!generation}
                >
                  <Option value=''/>
                  {(variants || []).map(o => {
                    return <Option value={o.id} key={o.id}>{o.name}</Option>
                  })}
                </Select>
              );
            }}
          />
      }
      {
        loadingEngines ? <LoaderLine containerStyle={{height: 'auto', background: 'transparent'}} loaderStyle={{ color: 'white' }} />
          :
          <TranslateText
            id="search__engine"
            style={{flexGrow: 1, height: 'auto', lineHeight: '55px', textAlign: 'center'}}
            place="bottom"
            render={text => {
              return (
                <Select
                  style={{flexGrow: 1, height: 'auto', lineHeight: '55px', textAlign: 'center'}}
                  imgNotFixed={true}
                  label={findLabel(engines, engine) || text}
                  value={engine}
                  onChange={(e) => {
                    const engine = findElement(engines, e.target.value)
                    setEngine(engine)
                  }}
                  theme='search'
                  disabled={!variant}
                >
                  <Option value=''/>
                  {(engines || []).map(o => {
                    return <Option value={o.id} key={o.id}>{o.name}</Option>
                  })}
                </Select>
              );
            }}
          />
      }
      <div style={{textAlign: 'center', flexGrow: 0, height: 55}}>
        <TranslateText
          id="search__pick-up"
          style={{ height: 'inherit' }}
          place="bottom"
          render={text => {
            return (
              <Button
                style={{
                  height: '100%',
                }}
                onClick={() => {
                  variant && browserHistory.push(`/selection?manufacturer_id=${manufacture}&model_id=${model}&generation_id=${generation}&variant_id=${variant}${engine ? `&engine_id=${engine}` : ''}`)
                }}
                theme='search'
                disabled={!variant}
              >
                {text}
              </Button>
            );
          }}
        />
      </div>
    </Container>
  )
}

export default Search




// WEBPACK FOOTER //
// ./src/finwhale/search/BiggerThan960.js